import axios from "axios";

// Soporta Vite (import.meta.env), CRA (process.env) y runtime (window.__ENV__)
const ENV = {
  ORIGIN:
    (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_ORIGIN) ||
    process.env.REACT_APP_API_ORIGIN ||
    (window.__ENV__ && window.__ENV__.API_ORIGIN) ||
    "", // si usas proxy en dev, esto puede quedarse vacío
  PREFIX:
    (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_PREFIX) ||
    process.env.REACT_APP_API_PREFIX ||
    "/api",
};

// Si usas proxy en desarrollo, deja ORIGIN vacío y usa base relativa "/api"
const baseURL = `${ENV.ORIGIN}${ENV.PREFIX}`;

// Instancia única
const api = axios.create({
  baseURL,
  timeout: 20000,
});

// Token (si tienes auth)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
export { baseURL };
